export type FooterLink = {
  label: string
  url: string
  external?: boolean
  huAction?: string
}

export type FooterSection = {
  title: string
  links: FooterLink[]
}

export const FOOTER_SECTIONS: FooterSection[] = [
  {
    title: 'RESOURCES',
    links: [
      {
        label: 'Tickets',
        url: 'https://www.premierlacrosseleague.com/tickets',
        external: true,
      },
      {
        label: 'PLL Shop',
        url: 'https://shop.premierlacrosseleague.com/',
        external: true,
      },
      {
        label: 'Careers',
        url: 'https://www.premierlacrosseleague.com/careers',
        external: true,
      },
      {
        label: 'Where to Watch',
        url: 'https://www.premierlacrosseleague.com/where-to-watch',
        external: true,
      },
      {
        label: 'Media Credentials',
        url: 'https://docs.google.com/forms/d/e/1FAIpQLSdMszHl0YIWOpgphfxTjI0ri-Ji167IpyhgLEOH9IC3ylGLRw/viewform',
        external: true,
      },
      {
        label: 'Contact Us',
        url: 'https://premierlacrosseleague.com/contact-page',
        external: true,
      },
    ],
  },
  {
    title: 'LEGAL',
    links: [
      {
        label: 'Privacy Policy',
        url: 'https://www.premierlacrosseleague.com/privacy-policy',
        external: true,
      },
      {
        label: 'Terms of Service',
        url: 'https://www.premierlacrosseleague.com/terms-of-service',
        external: true,
      },
      {
        label: 'Ticket Terms & Conditions',
        url: 'https://premierlacrosseleague.com/ticket-terms-conditions',
        external: true,
      },
      {
        label: 'Security Policy',
        url: 'https://www.premierlacrosseleague.com/security-policy',
        external: true,
      },
      {
        label: 'State-Specific Rights & Disclosures',
        url: 'https://premierlacrosseleague.com/state-specific-rights-and-disclosures',
        external: true,
      },
      {
        label: 'Exclusive Content License & Submission Policy',
        url: 'https://premierlacrosseleague.com/content-license-submission-policy',
        external: true,
      }
    ],
  },
]

export const APP_STORE_LINKS = {
  apple: 'https://apps.apple.com/us/app/premier-lacrosse-league/id1460690108',
  google: 'https://play.google.com/store/apps/details?id=com.premierlacrosseleague',
}
